import React, { useState } from 'react';
import PropTypes from 'prop-types';
import moment from 'moment-timezone';
import { View, Text } from 'react-native-web';
import { Range } from 'rc-slider';

import { isClient } from '../../../../environment';
import { defaultSliderStyles } from '../../../../components/Slider/Slider';
import styles from './styles';

if (isClient) {
  // eslint-disable-next-line global-require
  require('rc-slider/assets/index.css');
}

// Move to shared library once we fine a suitable compatable slider
const propTypes = {
  onUpdate: PropTypes.func.isRequired,
  timeLow: PropTypes.number.isRequired,
  timeHigh: PropTypes.number.isRequired,
};

const TimeFilter = ({ onUpdate, timeLow, timeHigh }) => {
  const [low, setLow] = useState(timeLow);
  const [high, setHigh] = useState(timeHigh);

  const { trackStyle, handleStyle } = defaultSliderStyles([low, high]);

  const onChange = ([newLow, newHigh]) => {
    setLow(newLow);
    setHigh(newHigh);
  };

  const onAfterChange = newRange => {
    onUpdate(newRange);
  };

  return (
    <View style={styles.container}>
      <Range
        min={0}
        max={1410}
        step={30}
        value={[low, high]}
        trackStyle={trackStyle}
        handleStyle={handleStyle}
        onChange={onChange}
        onAfterChange={onAfterChange}
      />
      <View style={styles.timesContainer}>
        <Text>{moment.utc().startOf('day').add(low, 'minutes').format('hh:mm A')}</Text>
        <Text>{moment.utc().startOf('day').add(high, 'minutes').format('hh:mm A')}</Text>
      </View>
    </View>
  );
};

TimeFilter.propTypes = propTypes;

export default TimeFilter;
